import { action } from 'mobx'
import Api from '@api/hotel/niuniu'
import BaseStore from 'hljd/esm/SearchBar/store'

class Store extends BaseStore {
  $listApi = Api.menulist

  $getParams = () => {
    return {
      status: 1,
      is_published: 1
    }
  }

  //向上
  @action
  upnum = id => async () => {
    let params = {
      id: id,
      btn: 5
    }
    const { success } = await Api.menufromsale(params)
    if (success) {
      this.$getList()
    }
  }

  //向下
  @action
  downnum = id => async () => {
    let params = {
      id: id,
      btn: 6
    }
    let { success } = await Api.menufromsale(params)
    if (success) {
      this.$getList()
    }
  }

  //置顶
  @action
  totop = id => async () => {
    let params = {
      id: id,
      btn: 3
    }
    let { success } = await Api.menufromsale(params)
    if (success) {
      this.$getList()
    }
  }
}
export default Store
